import { Observer } from 'mobx-react-lite';
import numeral from 'numeral';
import type { JSX } from 'react';
import React from 'react';
import type { ColumnRenderProps } from 'react-table';

import type { BaseCampaign, Campaign } from '@feathr/blackbox';
import type { IColumn } from '@feathr/components';
import { TableColumnHeader } from '@feathr/components';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

function weightedAvg(
  { rateSum, delSum },
  currentValue: { _original: Campaign },
): { rateSum: number; delSum: number } {
  const stats = currentValue._original.get('stats_cache');
  const rate = stats?.email_open_rate || 0;
  const dels = stats?.num_deliveries_email || 0;
  return {
    rateSum: rateSum + rate * dels,
    delSum: delSum + dels,
  };
}

const EmailOpenRateColumn: IColumn<BaseCampaign> = {
  id: 'stats_cache__email_open_rate',
  checkboxLabel: 'Email Open Rate',
  Header: TableColumnHeader({
    title: 'Email Open Rate',
  }),
  width: 140,
  sortable: false,
  className: tableStyles.cellRight,
  Cell({ original }): JSX.Element {
    return (
      <Observer>
        {(): JSX.Element => {
          const stats = original.get('stats_cache');
          const rate = stats?.email_open_rate || 0;
          return <>{numeral(rate).format('0%')}</>;
        }}
      </Observer>
    );
  },
  Footer({ data }: ColumnRenderProps<{ _original: Campaign }>): JSX.Element {
    return (
      <Observer>
        {(): JSX.Element => {
          const { rateSum, delSum } = data.reduce(weightedAvg, { rateSum: 0, delSum: 0 });
          const avg = delSum > 0 ? rateSum / delSum : 0;
          return <>{numeral(avg).format('0.00%')}</>;
        }}
      </Observer>
    );
  },
};

export default EmailOpenRateColumn;
